import React from 'react'
import PropTypes from 'prop-types'
import { Button, Empty, Spin } from 'antd'
import PrintReceiverForm from './PrintReceiverForm'
import WarehouseSlip from './WarehouseSlip'
import { getPrintInfoSource } from '../../helpers/print'

const SewingHandoverPrintPage = ({ loading, printing, handover, printInfo, onChangePrintInfo, onPrint, onExportCsv, onBack }) => {
    return (
        <div className='SewingHandoverPrintPage'>
            <div className='SewingHandoverPrintPage__toolbar no-print'>
                <h2 className='PageTitle'>Phiếu xuất kho</h2>
                <div className='SewingHandoverPrintPage__actions'>
                    <Button icon='left' onClick={onBack}>Quay lại lịch sử</Button>
                    <Button icon='download' disabled={!handover} onClick={onExportCsv}>Export CSV</Button>
                    <Button type='primary' icon='printer' loading={printing} disabled={!handover} onClick={onPrint}>
                        In phiếu
                    </Button>
                </div>
            </div>

            <Spin spinning={loading}>
                {handover ? (
                    <>
                        <PrintReceiverForm
                            value={printInfo}
                            source={getPrintInfoSource(handover)}
                            disabled={printing}
                            onChange={onChangePrintInfo}
                        />

                        <div className='WarehouseSlipWrapper'>
                            <WarehouseSlip handover={handover} printInfo={printInfo} />
                        </div>
                    </>
                ) : (
                    !loading && <Empty className='no-print' description='Không có dữ liệu phiếu xuất kho' />
                )}
            </Spin>
        </div>
    )
}

SewingHandoverPrintPage.propTypes = {
    loading: PropTypes.bool.isRequired,
    printing: PropTypes.bool.isRequired,
    handover: PropTypes.object,
    printInfo: PropTypes.object.isRequired,
    onChangePrintInfo: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
    onExportCsv: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
}

export default SewingHandoverPrintPage
